import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { devicePageModel } from 'pages/device-page/model';
import { DevicePageHeading } from '../device-page-heading';
import { DevicePageTabs } from '../device-page-tabs';
import cls from './device-page.module.scss';

export const DevicePage = () => {
	const [loading, currentTab] = useUnit([
		devicePageModel.$pending,
		devicePageModel.currentTabState.$value,
	]);

	return (
		<AppShell.Main
			className={cls.devicePage}
			data-tab={currentTab}
		>
			{loading ? (
				<Loader />
			) : (
				<>
					<DevicePageHeading />
					<DevicePageTabs />
				</>
			)}
		</AppShell.Main>
	);
};
